import * as angular from 'angular';
import { MxNovaLoader } from './nova-loader.service';
import { mxNovaChartPieComponent } from './components/mx-nova-chart-pie/mx-nova-chart-pie';

export const novaModule = angular.module('mx.nova', []).service('mx.nova.NovaLoader', MxNovaLoader).component('mxNovaChartPie', mxNovaChartPieComponent);
